const initialState = {
  status: false
};

function reducer(state = initialState, { type, payload }) {
  switch (true) {
    case /PENDING/i.test(type):
      return { ...state, status: true };

    case /FULFILLED|REJECTED/i.test(type):
      return { ...state, status: false };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/loading.ts